module.exports = __webpack_public_path__ + "img/about_us_tablet.ae4b803d.png";